/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1LocationCitiesIdMutationRequest,
  PutApiV1LocationCitiesIdMutationResponse,
  PutApiV1LocationCitiesIdPathParams,
  PutApiV1LocationCitiesId400,
  PutApiV1LocationCitiesId401,
  PutApiV1LocationCitiesId404,
  PutApiV1LocationCitiesId409,
  PutApiV1LocationCitiesId500,
} from "../../types/locationCityController/PutApiV1LocationCitiesId.ts";

function getPutApiV1LocationCitiesIdUrl(
  id: PutApiV1LocationCitiesIdPathParams["id"],
) {
  const res = { method: "PUT", url: `/api/v1/location/cities/${id}` as const };
  return res;
}

/**
 * @description Atualiza o código, o nome, o estado e a população de uma cidade. O código permanece único globalmente e o nome único dentro do estado. **(Requer Authorization para autenticação)**
 * @summary Atualizar cidade (Requer Authorization para autenticação)
 * {@link /api/v1/location/cities/:id}
 */
export async function putApiV1LocationCitiesId(
  id: PutApiV1LocationCitiesIdPathParams["id"],
  data?: PutApiV1LocationCitiesIdMutationRequest,
  config: Partial<RequestConfig<PutApiV1LocationCitiesIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1LocationCitiesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationCitiesId400
      | PutApiV1LocationCitiesId401
      | PutApiV1LocationCitiesId404
      | PutApiV1LocationCitiesId409
      | PutApiV1LocationCitiesId500
    >,
    PutApiV1LocationCitiesIdMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1LocationCitiesIdUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
